import { Component, input, output } from '@angular/core';
import { MedicalProfileHeaderComponent } from '../medical-profile-header/medical-profile-header.component';
import { PrescriptionRowComponent } from '../prescription-row/prescription-row.component';
import { ICustomerMedicalProfile, TOrderPrescriptionScriptItem } from '@chemist2u/types-client/C2U/Interfaces';

@Component({
    selector: 'app-past-prescription-card',
    templateUrl: './past-prescription-card.component.html',
    styleUrls: ['./past-prescription-card.component.scss'],
    imports: [MedicalProfileHeaderComponent, PrescriptionRowComponent]
})
export class PastPrescriptionCardComponent {
  public medicalProfile = input.required<Parse.Object.ToJSON<ICustomerMedicalProfile> & Parse.JSONBaseAttributes>();
  public items = input.required<TOrderPrescriptionScriptItem[]>();
  public emitProfile = input<boolean>(false);

  public scriptItemClick = output<TOrderPrescriptionScriptItem>();
  public scriptItemProfileClick = output<{ item: TOrderPrescriptionScriptItem, profile: Parse.Object.ToJSON<ICustomerMedicalProfile> & Parse.JSONBaseAttributes }>();

  // onScriptItemClick(event: MouseEvent, item: TOrderPrescriptionScriptItem) {
  //   event.stopPropagation();
  // if(!this.emitProfile()) {
  //   this.scriptItemClick.emit(item);
  // } else {
  //   this.scriptItemProfileClick.emit({ item: item, profile: this.medicalProfile() });
  // }

  // }

  onScriptReorder(item: TOrderPrescriptionScriptItem) {
    if (!this.emitProfile()) {
      this.scriptItemClick.emit(item);
    } else {
      this.scriptItemProfileClick.emit({ item: item, profile: this.medicalProfile() });
    }
  }

}